import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'

export default class ContentWarningIcon extends Component {
  render() {
    const { value, abbrev, showTooltip, text } = this.props

    const tooltipId = `${value + abbrev}-${Math.random()}`

    return (
      <div
        className="content-warning-icon"
        data-for={tooltipId}
        data-tip={text}
      >
        {showTooltip && <ReactTooltip id={tooltipId} effect={'solid'} />}
        <span className="abrev">{this.props.abbrev}</span>
      </div>
    )
  }
}

ContentWarningIcon.propTypes = {
  value: PropTypes.string.isRequired,
  showTooltip: PropTypes.bool,
  abbrev: PropTypes.string,
  text: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/mini/ContentWarningIcon.js